export interface FaqItem {
  question: string
  answer: string
}

export const faqs: FaqItem[] = [
  {
    question: 'How do I receive the package after purchasing?',
    answer:
      'You’ll receive instant digital access to all materials immediately after completing your purchase. All 6 volumes and 6 bonuses are PDF files. No waiting, no shipping, no complicated steps. Download everything to your computer or access it via your online account.',
  },
  {
    question: 'Do I need any special experience to use this?',
    answer:
      'No. This system is designed for art teachers of all experience levels — from brand new teachers to veterans. Every lesson is written to be taught as-is, without needing to adapt or rewrite. If you teach art, you can use this immediately.',
  },
  {
    question: 'Does this work for different grade levels?',
    answer:
      'Yes. Each volume includes lessons at beginner, intermediate, and advanced levels. Whether you teach elementary, middle school, high school, or a mixed-level classroom, you’ll find adaptations that work for your students’ age and experience.',
  },
  {
    question: 'Can I edit and customize the material?',
    answer:
      'Yes. All PDF materials are provided in an editable format. You can customize them to match your curriculum, add your school’s branding, or adapt them to your specific student needs. The system is yours to modify.',
  },
  {
    question: 'What format are the materials in?',
    answer:
      'Everything is 100% PDF. That means you can print it, project it, upload it to your learning management system, or share it digitally with students. It works on any device, and nothing needs to be updated or installed.',
  },
  {
    question: 'Can I use this if my school has limited materials or budget?',
    answer:
      'Absolutely. That’s why we included The Low-Budget Material Swap Guide as a bonus. Every project in the main volumes can be adapted using basic classroom materials, recycled items, or found objects. You don’t need fancy supplies to teach beautiful art.',
  },
  {
    question: 'What if this doesn’t work for me?',
    answer:
      'You receive exactly what we show and promise on this page. If within 7 days the content delivered doesn’t match the description here, you request your refund and we return 100% of your money. Our refund rate is under 0.5%.',
  },
  {
    question: 'Is this just a collection of worksheets?',
    answer:
      'No. This is a complete teaching system. It includes full lesson plans with learning objectives, step-by-step instructions, visual demonstrations, assessment tools, reflection pages, and material guidance. It’s professional curriculum, not random worksheets.',
  },
]
